import type { FormField } from "../../types";

export const mapFieldTypeBack = (type?: string): FormField["type"] => {
  switch (type) {
    case "dui_nit":
      return "identification";
    case "switch":
      return "switch";
    case "year":
      return "date";
    case "expedient":
      return "expedient";
    case "filtered_select":
      return "filtered-list";
    default:
      return (type as FormField["type"]) || "text";
  }
};

export const mapConditionTypeBackName = (conditionType: string): string => {
  switch (conditionType) {
    case "IS_EMPTY":
      return "Está vacío";
    case "IS_NOT_EMPTY":
      return "No está vacío";
    case "EQUALS":
      return "Es igual a";
    case "NOT_EQUALS":
      return "No es igual a";
    case "STARTS_WITH":
      return "Empieza con";
    case "ENDS_WITH":
      return "Termina con";
    case "GREATER_THAN":
      return "Es mayor a";
    case "LESS_THAN":
      return "Es menor a";
    case "GREATER_THAN_OR_EQUAL":
      return "Es mayor o igual a";
    case "LESS_THAN_OR_EQUAL":
      return "Es menor o igual a";
    case "EXISTS":
      return "Existe";
    case "NOT_EXISTS":
      return "No existe";
    case "CONTAINS":
      return "Contiene";
    case "NOT_CONTAINS":
      return "No contiene";
    case "IN_LIST":
      return "Está en la lista";
    case "NOT_IN_LIST":
      return "No está en la lista";

    case "IS_TRUE":
      return "Es verdadero";
    case "IS_FALSE":
      return "Es falso";

    case "IS_AFTER":
      return "Es después de";
    case "IS_BEFORE":
      return "Es antes de";
    case "IS_ON_OR_AFTER":
      return "Es después o igual a";
    case "IS_ON_OR_BEFORE":
      return "Es antes o igual a";

    default:
      return "Desconocido";
  }
};
